import fetcher from '@api/fetchers';

export const unsave = (objectUid, entityType) =>
  fetcher('v1/uplus/save/remove_from_saved/', {
    requestType: 'POST',
    body: {
      object_uid: objectUid,
      entity_type: entityType
    }
  });

export const save = (objectUid, entityType) =>
  fetcher('v1/uplus/save/add_to_saved/', {
    requestType: 'POST',
    body: {
      object_uid: objectUid,
      entity_type: entityType
    }
  });
